import { createRouter, createWebHistory } from "vue-router";
import { defaultTitle } from "../assets/scripts/config";
import List from "../views/UnitList.vue";
import UnitTitlesJson from "@/assets/json/unit_titles.json";
import LearningUnit01 from "../assets/json/learning_unit_01.json";
import LearningUnit02 from "../assets/json/learning_unit_02.json";
import LearningUnit03 from "../assets/json/learning_unit_03.json";
import LearningUnit04 from "../assets/json/learning_unit_04.json";
import LearningUnit05 from "../assets/json/learning_unit_05.json";
import LearningUnit06 from "../assets/json/learning_unit_06.json";
import LearningUnit07 from "../assets/json/learning_unit_07.json";
import LearningUnit08 from "../assets/json/learning_unit_08.json";
import LearningUnit09 from "../assets/json/learning_unit_09.json";
import LearningUnit10 from "../assets/json/learning_unit_10.json";
import LearningUnit11 from "../assets/json/learning_unit_11.json";
import LearningUnit12 from "../assets/json/learning_unit_12.json";
import LearningUnit13 from "../assets/json/learning_unit_13.json";
import LearningUnit14 from "../assets/json/learning_unit_14.json";
import LearningUnit15 from "../assets/json/learning_unit_15.json";
import LearningUnit16 from "../assets/json/learning_unit_16.json";
import LearningUnit17 from "../assets/json/learning_unit_17.json";
import LearningUnit18 from "../assets/json/learning_unit_18.json";
import LearningUnit19 from "../assets/json/learning_unit_19.json";
import LearningUnit20 from "../assets/json/learning_unit_20.json";
import LearningUnit21 from "../assets/json/learning_unit_21.json";
import LearningUnit22 from "../assets/json/learning_unit_22.json";
import LearningUnit23 from "../assets/json/learning_unit_23.json";
import LearningUnit24 from "../assets/json/learning_unit_24.json";
import LearningUnit25 from "../assets/json/learning_unit_25.json";
import LearningUnit26 from "../assets/json/learning_unit_26.json";
import LearningUnit27 from "../assets/json/learning_unit_27.json";
import LearningUnit28 from "../assets/json/learning_unit_28.json";
import LearningUnit29 from "../assets/json/learning_unit_29.json";
import LearningUnit30 from "../assets/json/learning_unit_30.json";
import LearningUnit31 from "../assets/json/learning_unit_31.json";
import LearningUnit32 from "../assets/json/learning_unit_32.json";
import LearningUnit33 from "../assets/json/learning_unit_33.json";
import LearningUnit34 from "../assets/json/learning_unit_34.json";
import LearningUnit35 from "../assets/json/learning_unit_35.json";
import LearningUnit36 from "../assets/json/learning_unit_36.json";
import LearningUnit37 from "../assets/json/learning_unit_37.json";
import LearningUnit38 from "../assets/json/learning_unit_38.json";
import store from "@/store/index.js";

const { unit_titles } = UnitTitlesJson;

const getUnitTitle = (unitTitles) => {
  const sideMenuTitle = unitTitles.side_menu_title;
  console.log(sideMenuTitle);
  const hasSideMenuTitle = !(
    sideMenuTitle === undefined || sideMenuTitle === ""
  );
  console.log(hasSideMenuTitle);
  return hasSideMenuTitle ? unitTitles.side_menu_title : unitTitles.title;
};

const routes = [
  {
    path: "/",
    name: "List",
    component: List,
    meta: { title: "NEW HORIZON English Course 1ホーム" },
    props: {
      unitTitlesJson: UnitTitlesJson,
    },
  },
  {
    path: "/a/",
    name: "a",
    component: () =>
      import(/* webpackChunkName: "A" */ "../views/LearningUnit.vue"),
    meta: { title: "巻頭資料" },
    props: {
      unitTitle: getUnitTitle(unit_titles[0]),
      learningUnitJson: LearningUnit01,
    },
  },
  {
    path: "/b/",
    name: "b",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 0　Nice to Meet You"},
    props: {
      unitTitle: getUnitTitle(unit_titles[1]),
      learningUnitJson: LearningUnit02,
    },
  },
  {
    path: "/c/",
    name: "c",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Sounds and Letters 0" },
    props: {
      unitTitle: getUnitTitle(unit_titles[2]),
      learningUnitJson: LearningUnit03,
    },
  },
  {
    path: "/d/",
    name: "d",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Grammar for Communication 0" },
    props: {
      unitTitle: getUnitTitle(unit_titles[3]),
      learningUnitJson: LearningUnit04,
    },
  },
  {
    path: "/e/",
    name: "e",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 1　Hello, Everyone!" },
    props: {
      unitTitle: getUnitTitle(unit_titles[4]),
      learningUnitJson: LearningUnit05,
    },
  },
  {
    path: "/f/",
    name: "f",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Sounds and Letters 1" },
    props: {
      unitTitle: getUnitTitle(unit_titles[5]),
      learningUnitJson: LearningUnit06,
    },
  },
  {
    path: "/g/",
    name: "g",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 2　Our New Teacher" },
    props: {
      unitTitle: getUnitTitle(unit_titles[6]),
      learningUnitJson: LearningUnit07,
    },
  },
  {
    path: "/h/",
    name: "h",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Sounds and Letters 2" },
    props: {
      unitTitle: getUnitTitle(unit_titles[7]),
      learningUnitJson: LearningUnit08,
    },
  },
  {
    path: "/i/",
    name: "i",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Column（Canada）" },
    props: {
      unitTitle: getUnitTitle(unit_titles[8]),
      learningUnitJson: LearningUnit09,
    },
  },
  {
    path: "/j/",
    name: "j",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 3　Our School" },
    props: {
      unitTitle: getUnitTitle(unit_titles[9]),
      learningUnitJson: LearningUnit10,
    },
  },
  {
    path: "/k/",
    name: "k",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Sounds and Letters 3" },
    props: {
      unitTitle: getUnitTitle(unit_titles[10]),
      learningUnitJson: LearningUnit11,
    },
  },
  {
    path: "/l/",
    name: "l",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 4　Friends in New Zealand" },
    props: {
      unitTitle: getUnitTitle(unit_titles[11]),
      learningUnitJson: LearningUnit12,
    },
  },
  {
    path: "/m/",
    name: "m",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Sounds and Letters 4" },
    props: {
      unitTitle: getUnitTitle(unit_titles[12]),
      learningUnitJson: LearningUnit13,
    },
  },
  {
    path: "/n/",
    name: "n",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Column（New Zealand）" },
    props: {
      unitTitle: getUnitTitle(unit_titles[13]),
      learningUnitJson: LearningUnit14,
    },
  },
  {
    path: "/o/",
    name: "o",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Stage Activity 1　\"All about Me\" Poster" },
    props: {
      unitTitle: getUnitTitle(unit_titles[14]),
      learningUnitJson: LearningUnit15,
    },
  },
  {
    path: "/p/",
    name: "p",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Our Summer Vacations" },
    props: {
      unitTitle: getUnitTitle(unit_titles[15]),
      learningUnitJson: LearningUnit16,
    },
  },
  {
    path: "/q/",
    name: "q",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 5　My Brother in Hawaii" },
    props: {
      unitTitle: getUnitTitle(unit_titles[16]),
      learningUnitJson: LearningUnit17,
    },
  },
  {
    path: "/r/",
    name: "r",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 1　コマーシャル" },
    props: {
      unitTitle: getUnitTitle(unit_titles[17]),
      learningUnitJson: LearningUnit18,
    },
  },
  {
    path: "/s/",
    name: "s",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 6　A Rakugo Performer from the U.K." },
    props: {
      unitTitle: getUnitTitle(unit_titles[18]),
      learningUnitJson: LearningUnit19,
    },
  },
  {
    path: "/t/",
    name: "t",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 2　友達の家で" },
    props: {
      unitTitle: getUnitTitle(unit_titles[19]),
      learningUnitJson: LearningUnit20,
    },
  },
  {
    path: "/u/",
    name: "u",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Grammar for Communication 5" },
    props: {
      unitTitle: getUnitTitle(unit_titles[20]),
      learningUnitJson: LearningUnit21,
    },
  },
  {
    path: "/v/",
    name: "v",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 7　An Online Tour of the U.K." },
    props: {
      unitTitle: getUnitTitle(unit_titles[21]),
      learningUnitJson: LearningUnit22,
    },
  },
  {
    path: "/w/",
    name: "w",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 3　道案内" },
    props: {
      unitTitle: getUnitTitle(unit_titles[22]),
      learningUnitJson: LearningUnit23,
    },
  },
  {
    path: "/x/",
    name: "x",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 8　Think Globally, Act Locally" },
    props: {
      unitTitle: getUnitTitle(unit_titles[23]),
      learningUnitJson: LearningUnit24,
    },
  },
  {
    path: "/y/",
    name: "y",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 4　レストラン" },
    props: {
      unitTitle: getUnitTitle(unit_titles[24]),
      learningUnitJson: LearningUnit25,
    },
  },
  {
    path: "/z/",
    name: "z",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Stage Activity 2　My Hero" },
    props: {
      unitTitle: getUnitTitle(unit_titles[25]),
      learningUnitJson: LearningUnit26,
    },
  },
  {
    path: "/0/",
    name: "0",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Column（Africa）" },
    props: {
      unitTitle: getUnitTitle(unit_titles[26]),
      learningUnitJson: LearningUnit27,
    },
  },
  {
    path: "/1/",
    name: "1",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 9　Winter Vacation" },
    props: {
      unitTitle: getUnitTitle(unit_titles[27]),
      learningUnitJson: LearningUnit28,
    },
  },
  {
    path: "/2/",
    name: "2",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 5　旅先からの便り" },
    props: {
      unitTitle: getUnitTitle(unit_titles[28]),
      learningUnitJson: LearningUnit29,
    },
  },
  {
    path: "/3/",
    name: "3",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 10　This Year's Memories" },
    props: {
      unitTitle: getUnitTitle(unit_titles[29]),
      learningUnitJson: LearningUnit30,
    },
  },
  {
    path: "/4/",
    name: "4",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 6　病院にて" },
    props: {
      unitTitle: getUnitTitle(unit_titles[30]),
      learningUnitJson: LearningUnit31,
    },
  },
  {
    path: "/5/",
    name: "5",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Learning Literature in English" },
    props: {
      unitTitle: getUnitTitle(unit_titles[31]),
      learningUnitJson: LearningUnit37,
    },
  },
  {
    path: "/6/",
    name: "6",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Stage Activity 3　My Favorite Event This Year"},
    props: {
      unitTitle: getUnitTitle(unit_titles[32]),
      learningUnitJson: LearningUnit32,
    },
  },
  {
    path: "/7/",
    name: "7",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Let's Read　Gon, the Fox" },
    props: {
      unitTitle: getUnitTitle(unit_titles[33]),
      learningUnitJson: LearningUnit33,
    },
  },
  {
    path: "/8/",
    name: "8",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "英語の音と文字" },
    props: {
      unitTitle: getUnitTitle(unit_titles[34]),
      learningUnitJson: LearningUnit34,
    },
  },
  {
    path: "/9/",
    name: "9",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "My Diary" },
    props: {
      unitTitle: getUnitTitle(unit_titles[35]),
      learningUnitJson: LearningUnit38,
    },
  },
  {
    path: "/10/",
    name: "10",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "語順カード" },
    props: {
      unitTitle: getUnitTitle(unit_titles[36]),
      learningUnitJson: LearningUnit35,
    },
  },
  {
    path: "/11/",
    name: "11",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "資料編" },
    props: {
      unitTitle: getUnitTitle(unit_titles[37]),
      learningUnitJson: LearningUnit36,
    },
  },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title || defaultTitle;
});

router.beforeEach(() =>{
  store.commit(
    "toggleDarkMode",
    localStorage.getItem("darkModeFrag") === "true"
  );
});

export default router;